@if (expanded) {
  <div class="filler"></div>
}
<div class="container" [class.expanded]="expanded">
  <div class="top-section" [class.expanded]="expanded">
    @if (expanded) {
      <img src="assets/images/navigation/logo-expanded.svg" alt="logotipo da sabesp com nome" class="logo" />
    } @else {
      <img src="assets/images/navigation/logo.svg" alt="logotipo da sabesp" class="logo" />
    }
    <span
      role="button"
      class="navigation-expand-trigger"
      nz-icon
      [nzType]="expanded ? 'arrow-left' : 'arrow-right'"
      (click)="expanded = !expanded"
      (keypress)="$event.key === 'Enter' && (expanded = !expanded)"
      tabindex="0"
    ></span>
  </div>
  <div class="bottom-section">
    <div class="navigation-list">
      @for (item of items(); track item.label) {
        <app-side-navigation-item
          [item]="item"
          [expanded]="expanded"
          (expandRequest)="expanded = true"
          nz-tooltip
          [nzTooltipTitle]="expanded ? null : item.label"
          nzTooltipPlacement="right"
        />
      }
      <app-side-navigation-item
        [item]="itemSair()"
        [expanded]="expanded"
        (click)="sessao.encerrarSessao()"
        (keypress)="$event.key === 'Enter' && sessao.encerrarSessao()"
        nz-tooltip
        [nzTooltipTitle]="expanded ? null : itemSair().label"
        nzTooltipPlacement="right"
      />
    </div>
  </div>
</div>
